import React from "react";
import ReactMarkdown, {Components} from "react-markdown";
import {calcTimeDiff} from "../../chatbotUtil";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {ChatMessage} from "../../chatbotSlice";


const components = {
    // @ts-ignore
    a: ({href, children}) => {
        return (
            <a
                href={href}
                target="_blank"
                style={{textDecoration: "underline"}}
            >
                {children}
            </a>
        );
    },
} as Components;

interface BotImageMessageProps {
    index: number
    message: ChatMessage
    registration?: string
}

export const BotImageMessage: React.FC<BotImageMessageProps> = ({
                                                                    index,
                                                                    message
                                                                }) => {

    const vehicle = message.message.vehicle;

    return (
        <div key={index} className="mt-4 relative self-start w-full">
            <div className="flex flex-row justify-between">
                <div className="flex flex-col w-[85%]">
                    <div className="rounded-xl border-[1px] text-gray-900 py-3 px-4 bg-white">
                        {vehicle?.redirect_url ?
                            (
                                <a className="relative flex overflow-hidden object-cover opacity-1/2"
                                   href={vehicle?.redirect_url}
                                   target="_blank">
                                    <img
                                        className="mb-1 rounded-2xl w-full"
                                        src={vehicle.image_url}
                                    />
                                </a>
                            ) : (
                                <img
                                    className="mb-1 rounded-2xl w-full"
                                    src={vehicle?.image_url}
                                />
                            )}
                        <div className="text-gray-900 overflow-wrap-anywhere">
                            <ReactMarkdown components={components}>
                                {message.message.message}
                            </ReactMarkdown>
                        </div>
                    </div>
                    <div className="text-gray-500 ml-2 mt-1 text-[12px]"
                         suppressHydrationWarning>
                        {calcTimeDiff(message.time)}
                    </div>
                </div>
            </div>
        </div>
    );
}
